export const setLayoutKeyValue =
  (key: string, value: any) => (dispatch: Function) => {
    dispatch({
      type: 'SET_LAYOUT_KEY_VALUE',
      payload: { key, value },
    });
  };
